const styles = `
  .btn {
    border-radius: 0px;
  }
  .btn-primary {
    background-color: #19ab73;
  }
  .whatsapp {
    position: fixed;
    bottom: 20px;
    right: 20px;
  }
  .whatsapp img {
    width: 50px;
    cursor: pointer;
  } 
`;

export default styles;



// WEBPACK FOOTER //
// ./src/globalstyles/Site.js